import { sortByScore } from './dietSorter';

export const getSortStrategy = (resultsConfig)=>{
    const strategies = {
        sortByDietScores,
        sortById,
        none: echo
    };
    const { sortStrategy } = resultsConfig;

    if(! strategies[sortStrategy]){
        return echo;
    }

    return strategies[sortStrategy];
};

const echo = (allResults, selectedFilters)=>{
    return allResults;
};

const sortByDietScores = (allResults, selectedFilters)=>{
    return sortByScore(allResults, selectedFilters);
};

const sortById = (allResults, selectedFilters)=>{
    return allResults.sort((res1, res2) => res1.id - res2.id);
};